export default "__VITE_ASSET__4bfc3351__"